const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isStandalone = !!(iOS && window.navigator.standalone);

export default theme => ({
  formWrapper: {
    padding: '20px 0 15px 15px',
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      padding: '20px 15px 15px',
    },
    [theme.breakpoints.up('md')]: {
      width: '100%',
      minWidth: '512px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '100%',
      // minWidth: '512px', // temporary
    },
  },
  closeButton: {
    position: 'absolute',
    right: 12,
    top: isStandalone ? 34 : 14,
    padding: 5
  },
  buttonHolder: {
    textAlign: 'center',
  },
  cancelButton: {
    margin: 20,
    minWidth: 100,
    '&:hover': {
      color: 'inherit'
    },
    '&:disabled': {
      backgroundColor: '#fff',
    },
  },
  saveButton: {
    margin: 20,
    minWidth: 100,
    '&:hover': {
      color: theme.palette.textColor.primary,
    },
    '&:disabled': {
      backgroundColor: '#fff',
    },
  },
  formFlex: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '95vh',
  },
  formInsideNotes: {
    minHeight: 'unset!important'
  },
  deleteButton: {
    minWidth: 28,
    height: 34,
    padding: 5,
    '&:hover': {
      background: '#fff !important',
    }
  },
  userPhotoWrapper: {
    borderRadius: '50%',
    border: `1px solid ${theme.palette.primary.blue}`,
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    width: 32,
    height: 32,
    transform: 'rotate(135deg)',
    marginRight: 20
  },
  userPhoto: {
    display: 'block',
    transform: 'rotate(-135deg)',
    height: 26,
    margin: '2px auto 0'
  },
  flexBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px 0 10px'
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  headerSecondText: {
    color: theme.palette.textColor.secondary,
    display: 'inline-block',
    marginLeft: 10
  },
  deleteIcon: {
    paddingTop: 6
  },
  searchBtn: {
    textTransform: 'none',
    padding: '3px 8px',
    color: theme.palette.textColor.blue,
    '&:hover': {
      color: theme.palette.textColor.blue,
      backgroundColor: '#fff !important',
    },
    '&:focus': {
      color: theme.palette.textColor.blue,
      backgroundColor: '#fff !important',
    },
    '&:disabled': {
      color: theme.palette.textColor.blue,
      backgroundColor: '#fff !important',
    }
  },
  marginBottomSmall: {
    marginBottom: 5
  },
  marginBottomNormal: {
    marginBottom: 10
  },
  wordBreak: {
    wordBreak: 'break-word',
  },
  paddingRight: {
    paddingRight: 15,
  }
});
